<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">To our parents. We're so sorry.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?26bc018e